import { Carousel } from "antd";
import { useRef } from "react";
import ArrowLeft from "../../../assets/web/icons/ArrowLeft";
import ArrowRight from "../../../assets/web/icons/ArrowRight";
import MediaCoveragePic1 from "../../../assets/web/images/media-coverage-1.png";
import MediaCoveragePic2 from "../../../assets/web/images/media-coverage-2.png";
import Shape7 from "../../../assets/web/images/shape-7.svg";
import Container from "../Container";
import PrimaryButton from "../PrimaryButton";

const MediaCoverage = () => {
  const carouselRef = useRef<any>(null);

  const goToPrev = () => {
    carouselRef.current?.prev();
  };

  const goToNext = () => {
    carouselRef.current?.next();
  };

  return (
    <section className="py-20">
      <Container>
        <div className="grid grid-cols-1 md:grid-cols-7 gap-4">
          <div className="col-span-2">
            <div className="text-3xl md:text-[48px] font-bold">
              We are on{" "}
              <span className="relative">
                News
                <img
                  src={Shape7}
                  className="absolute bottom-[10px] -right-[50px]"
                  alt=""
                />
              </span>
            </div>
          </div>
          <div className="col-span-5">
            <div className="slider-container relative">
              <Carousel
                slidesToShow={2}
                autoplay
                draggable
                arrows
                className="carousel-media-coverage"
                ref={carouselRef}
              >
                <div>
                  <img
                    src={MediaCoveragePic1}
                    className="w-full outline-none"
                    alt=""
                  />
                </div>
                <div>
                  <img
                    src={MediaCoveragePic2}
                    className="w-full outline-none"
                    alt=""
                  />
                </div>
                <div>
                  <img
                    src={MediaCoveragePic1}
                    className="w-full outline-none"
                    alt=""
                  />
                </div>
                <div>
                  <img
                    src={MediaCoveragePic2}
                    className="w-full outline-none"
                    alt=""
                  />
                </div>
              </Carousel>
              <div className="absolute right-0 -bottom-10 flex gap-2">
                <PrimaryButton onClick={goToPrev}>
                  <ArrowLeft />
                </PrimaryButton>
                <PrimaryButton onClick={goToNext}>
                  <ArrowRight />
                </PrimaryButton>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default MediaCoverage;
